module.exports = __webpack_public_path__ + "img/pr-2.8539f4ed.png";